import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './store/actions'
import * as getters from './store/getters'

import token from './store/modules/token'
import user from './store/modules/user'
import study from './store/modules/study'
import message from './store/modules/message'
import shrink from './store/modules/shrink'
import auth from './store/modules/auth'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  actions,
  getters,
  modules: {
    token,
    user,
    study,
    message,
    shrink,
    auth
  },
  strict: debug
})
